<!-- <app-header></app-header> -->
<!-- <app-loader></app-loader> -->

<div class="container margin-top-70" *ngIf="!showLoader">
  <div class="container">
    <div class="col-md-3 offset-9 pull-right">
      <!-- <select class="form-select" aria-label="Default select example" [(ngModel)]="selectedStatus" (change)="getSelectedStatus($event)">
                <option selected value="">Open this select menu</option>
                <option *ngFor="let productStatus of ProductStatusList;" value="{{productStatus.id}}">{{ productStatus.name }}</option>
              </select> -->
    </div>
  </div>

  <!-- <div class="container">
        <app-search-bar (searchProductEvent)="searchProduct($event)"></app-search-bar>
    </div> -->

  <div class="container">
    <div class="row">
      <div class="col-md-2">
        <label for="ID" class="form-label">Product ID</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="selectedproductId"
          placeholder=""
        />
      </div>

      <div class="col-md-4">
        <label for="Book Type" class="form-label">Product Type</label>
        <app-drop-down
          type="productType"
          [settings]="dropdownSettingsProductType"
          [list]="dropdownListProductType"
          (dropDownChanged)="updateSelectedDropDown($event)"
        ></app-drop-down>
      </div>

      <div class="col-md-4">
        <label for="Book Type" class="form-label">Book Type</label>
        <app-drop-down
          type="bookType"
          [settings]="dropdownSettingsBookType"
          [list]="dropdownListBookType"
          (dropDownChanged)="updateSelectedDropDown($event)"
        ></app-drop-down>
      </div>

      <div class="col-md-2 mt-4">
        <button
          type="submit"
          class="btn search-btn btn-primary"
          (click)="searchProduct()"
        >
          Search
        </button>
      </div>
    </div>
  </div>

  <div>
    <br />
  </div>

  <app-search-note></app-search-note>

  <div class="container">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" style="width: 10%;">ID</th>
          <th scope="col" style="width: 30%;">Title</th>
          <th scope="col" style="width: 30%;">Published Date</th>
          <th scope="col" style="width: 10%;">Status</th>
          <!-- <th scope="col" style="width: 10%">Publish</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of Products;">
          <!-- <th scope="row"><input (change)="getCheckboxValues($event,product)" type="checkbox"></th> -->
          <th scope="row">
            <a
              href="{{apiURL}}/#/products/record/{{product.id}}"
              target="_blank"
              >{{product.part_number}}</a
            >
          </th>
          <td>{{product.name}}</td>
          <td>
            <app-date
              [product]="product"
              type="publishingDate"
              [inputDate]="product?.publishing_date"
              (dateSelected)="updateIepd($event)"
              [productId]="product.id"
            ></app-date>
            <!-- <input type="text" id="{{product.id }}" ngbDatepicker #d="ngbDatepicker" [(ngModel)]="date" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button> -->
          </td>
          <td>{{product.status}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- <div class="container">
        <nav aria-label="Page navigation">
            <ul class="pagination justify-content-center">
                <li class="page-item disabled">
                    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                </li>
                <li class="page-item active" aria-current="page">
                    <a class="page-link" href="#">1</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#">2</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#">3</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#">4</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#">5</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#">Next</a>
                </li>
            </ul>
        </nav>

    </div> -->

  <ng-template #mymodal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Confirmation</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      Are you sure you want to save this change?
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-danger"
        (click)="modal.dismiss('cancel')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-success"
        (click)="modal.dismiss('save')"
      >
        Save
      </button>
    </div>
  </ng-template>

  <ngb-toast
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 1200;"
    *ngIf="processingToastShow"
    [autohide]="false"
    (hidden)="processingToastShow=false"
  >
    Processing update...
  </ngb-toast>

  <ngb-toast
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 1200; background-color: #198754; color: aliceblue;"
    *ngIf="successToastShow"
    [autohide]="true"
    (hidden)="successToastShow=false"
  >
    Request processed successfully!
  </ngb-toast>
</div>
